/**
 * CSV/Excel import preview dialog for customers.
 *
 * Extracted from Customers.jsx to keep that file focused on the main list
 * + edit flows. The dialog is purely presentational: it shows the parsed
 * rows in a table and exposes two actions (cancel / confirm).
 *
 * The host page owns the data + the actual import call so this component
 * stays stateless and easy to reason about.
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function CustomerImportPreviewDialog({
  open,
  onOpenChange,
  rows = [],
  onCancel,
  onConfirm,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto" data-testid="customer-import-preview">
        <DialogHeader>
          <DialogTitle>Vista Previa de Importación CSV</DialogTitle>
        </DialogHeader>
        <div className="mt-4">
          {rows.length > 0 ? (
            <>
              <p className="text-sm text-slate-600 mb-4">
                Se importarán {rows.length} clientes. Revisa los datos antes de finalizar.
              </p>
              <div className="border border-slate-200 rounded-sm overflow-x-auto max-h-96">
                <table className="w-full text-sm">
                  <thead className="bg-slate-50 sticky top-0">
                    <tr className="border-b border-slate-200">
                      <th className="text-left py-2 px-3 font-medium text-slate-600">Nombre Facturación</th>
                      <th className="text-left py-2 px-3 font-medium text-slate-600">Nombre Fantasía</th>
                      <th className="text-left py-2 px-3 font-medium text-slate-600">Teléfono</th>
                      <th className="text-left py-2 px-3 font-medium text-slate-600">Email</th>
                      <th className="text-left py-2 px-3 font-medium text-slate-600">Ubicación</th>
                      <th className="text-left py-2 px-3 font-medium text-slate-600">Categoría</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={index} className="border-b border-slate-100">
                        <td className="py-2 px-3">{row.nombre_facturacion || row.nombre_cliente || '-'}</td>
                        <td className="py-2 px-3">{row.nombre_fantasia || '-'}</td>
                        <td className="py-2 px-3">{row.phone || row.telefono1 || '-'}</td>
                        <td className="py-2 px-3">{row.email || '-'}</td>
                        <td className="py-2 px-3">{[row.provincia, row.canton, row.distrito].filter(Boolean).join(', ') || '-'}</td>
                        <td className="py-2 px-3">{row.category || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flex justify-end gap-3 mt-6">
                <Button
                  type="button"
                  variant="outline"
                  onClick={onCancel}
                  className="rounded-sm"
                >
                  Cancelar
                </Button>
                <Button
                  onClick={onConfirm}
                  className="btn-primary rounded-sm"
                  data-testid="finalize-import-button"
                >
                  Finalizar Importación
                </Button>
              </div>
            </>
          ) : (
            <p className="text-center py-8 text-slate-500">No hay datos para previsualizar</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
